export const clamp = (v: number, lo: number, hi: number): number => Math.max(lo, Math.min(hi, v));

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** 0〜1 に収めてから `t²(3−2t)` でなめらかにする。 */
export const smoothstep = (t: number): number => (t <= 0 ? 0 : t >= 1 ? 1 : t * t * (3 - 2 * t));

/** 点 (x, z) が、中心 (cx, cz)・幅 w・奥行き d の長方形の中（辺を含む）にあるか。 */
export const inRect = (
  x: number,
  z: number,
  cx: number,
  cz: number,
  w: number,
  d: number,
): boolean => Math.abs(x - cx) <= w / 2 && Math.abs(z - cz) <= d / 2;
